import React, {ReactElement} from "react"

const BookmarkOffIcon = (): ReactElement => {
	return (
		<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.16602 5.5C1.16602 4.09987 1.16602 3.3998 1.4385 2.86502C1.67818 2.39462 2.06063 2.01217 2.53104 1.77248C3.06582 1.5 3.76588 1.5 5.16602 1.5H8.83268C10.2328 1.5 10.9329 1.5 11.4677 1.77248C11.9381 2.01217 12.3205 2.39462 12.5602 2.86502C12.8327 3.3998 12.8327 4.09987 12.8327 5.5V16.5L6.99935 13.1667L1.16602 16.5V5.5Z"
	      stroke="#17253C"
	      strokeWidth="1.5"
	      strokeLinecap="round"
	      strokeLinejoin="round"
			/>
		</svg>

	)
}
export default BookmarkOffIcon
